import { render, staticRenderFns } from "./CommonTableFooter.vue?vue&type=template&id=34cd37cc&lang=pug&"
import script from "./CommonTableFooter.vue?vue&type=script&lang=ts&"
export * from "./CommonTableFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CommonTableFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports